<template>
  <div class="animated fadeIn list-of-coa">
    <b-card>
      <div slot="header">Trial Balance Unit Bisnis (DATA SOURCE)
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="showForm=true" :disabled="(frmdata.erpsource!=1)"><i class="fa fa-exchange"></i> Get from ERP</b-button>
          <b-button variant="primary mr-1" @click="showUploadFrm=true"><i class="fa fa-cloud-upload"></i> Import/Upload</b-button>
          <b-button variant="btn btn-primary mr-1" @click="exportxls">Export</b-button>
          <b-button variant="btn btn-primary" @click="close">Close</b-button>
        </div>
      </div>
      <b-row >
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <span class="p-2">Periode</span>
            </b-input-group-prepend>
            <vue-monthly-picker
              v-model="frmdata.periode"
              dateFormat="MMMM YYYY"
              :monthLabels="monthLabels"
              @selected="onChangeMonth"
              style="width: 332px !important;"
            ></vue-monthly-picker>
            <b-input-group-prepend>
              <span class="pl-3 pt-2 pr-2">Unit Bisnis</span>
            </b-input-group-prepend>
            <!-- <b-form-select
              v-model="frmdata.compcode"
              :plain="true"
              :options="companies"
            ></b-form-select> -->
                  <b-form-input readonly v-model="frmdata.company" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="lkuCompanyShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
            <b-button class="btn btn-success ml-2" @click="getData()" > <i class="fa fa-play"></i> Open</b-button>

          </b-input-group>
        </b-col>
        <b-col lg="4">
            <b-input-group size="sm" v-if="(filterShow=='Hide')">
                <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="pt-1"></b-form-checkbox>
                  <b-input-group-prepend> <span class="pt-1 pr-2">
                      <b> {{ filterShow }}</b>  Filter </span>
                  </b-input-group-prepend>
                <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
            </b-input-group >
            <b-input-group size="sm" v-else>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="pt-1">
              </b-form-checkbox>
                  <b-input-group-prepend> <span class="pt-1 pr-2">
                      <b> {{ filterShow }}</b>  Filter </span>
                  </b-input-group-prepend>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="tblData.items"
        :fields="tblData.fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
            :filter="filter"
            :filterIncludedFields="filterOn"
            @filtered="onFiltered"                
      >
        <template v-slot:cell(namaacc)="data">
          <!-- <span v-if="(data.item.judul=='Y')" v-html="data.item.accname" style="font-weight:bold;"></span>
          <span v-else v-html="data.item.accname"></span> -->
          <span v-if="(data.item.judul=='Y')"  style="font-weight:bold;" :style="`margin-left:${data.item.level_*5}px`">{{data.item.namaacc}}</span>
          <span v-else  :style="`margin-left:${data.item.level_*5}px`">{{data.item.namaacc}}</span>
        </template>
        <template v-slot:cell(awal)="data">
          <span v-if="(data.item.judul=='Y')" style="font-weight:bold;">{{data.item.awal|numFormat}}</span>
          <span v-else>{{data.item.awal|numFormat}}</span>
        </template>
        <template v-slot:cell(debet)="data">
          <span v-if="(data.item.judul=='Y')" style="font-weight:bold;">{{data.item.debet|numFormat}}</span>
          <span v-else>{{data.item.debet|numFormat}}</span>
        </template>
        <template v-slot:cell(kredit)="data">
          <span v-if="(data.item.judul=='Y')" style="font-weight:bold;">{{data.item.kredit|numFormat}}</span>
          <span v-else>{{data.item.kredit|numFormat}}</span>
        </template>
        <template v-slot:cell(akhir)="data">
          <span v-if="(data.item.judul=='Y')" style="font-weight:bold;">{{data.item.akhir|numFormat}}</span>
          <span v-else>{{data.item.akhir|numFormat}}</span>
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <b-modal v-model="showForm" size="md" title="Get TB from ERP" @ok="getfromERP">
          <b-input-group>
            <b-input-group-prepend>
              <label>Accounting Period</label>
            </b-input-group-prepend>
            <vue-monthly-picker
              v-model="frmdata.periode"
              dateFormat="MMMM YYYY"
              :monthLabels="monthLabels"
              @selected="onChangeMonth"
              style="width: 332px !important;"
            ></vue-monthly-picker>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Unit Bisnis</label>
            </b-input-group-prepend>
            <!-- <b-form-select
              v-model="frmdata.compcode"
              :plain="true"
              :options="companies"
            ></b-form-select> -->
                  <b-form-input readonly v-model="frmdata.company" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="lkuCompanyShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
          </b-input-group>
    </b-modal>
    <b-modal v-model="showUploadFrm" size="lg" title="Import/Upload TB Unit Bisnis" @ok="uploadTB">
          <b-input-group>
            <b-input-group-prepend>
              <label>Accounting Period</label>
            </b-input-group-prepend>
            <vue-monthly-picker
              v-model="frmdata.periode"
              dateFormat="MMMM YYYY"
              :monthLabels="monthLabels"
              @selected="onChangeMonth"
              style="width: 332px !important;"
            ></vue-monthly-picker>
            <b-input-group-prepend>
              <span class="pl-3 pt-2 pr-2">Unit Bisnis</span>
            </b-input-group-prepend>
            <!-- <b-form-select
              v-model="frmdata.compcode"
              :plain="true"
              :options="companies"
            ></b-form-select> -->
                  <b-form-input readonly v-model="frmdata.company" ></b-form-input>
                  <b-input-group-append>
                  <b-btn text="Button" @click="lkuCompanyShow=true" >
                      <i class="fa fa-search"></i>
                  </b-btn>
                  </b-input-group-append>
          </b-input-group>
      <b-input-group>
        <b-input-group-prepend>
          <label >Choose *.XLSX file</label>
        </b-input-group-prepend>
        <b-form-file
          v-model="fileXlsx"
          :state="Boolean(fileXlsx)"
          placeholder="Choose a XLSX file..."
          drop-placeholder="Drop XLSX file here..."
        ></b-form-file>
      </b-input-group>
      <div style="display:blocked; text-align:right;">
        <b-link @click="downloadtemplate"><i class="fa fa-paperclip"></i> EkosSystem-TB-upload-template.xlsx</b-link>
      </div>      
      <p  class="font-weight-bold m-0 text-danger"> Warning:  &nbsp;&nbsp;  Please Check Chart Of Account(COA) mapping,  COA Unit Bussines vs COA Consolidation </p>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Print Chart Of Account">
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuCompanyShow" size="lg"  :hide-footer="true" title="Consolidation Company" :centered="true">
            <lku-company @click="onSelectLkuCompany"></lku-company>
        </b-modal>        

  </div>
</template>



<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueMonthlyPicker from "vue-monthly-picker";
import toastr from "mini-toastr";
import moment from "moment";
import consoltb from "../../apis/consolidatb";
import dropdown from "../../data/dropdown";
import lkuCompany from "../lookup/lkuConsolidaCompany"
import vNumber from "vue-numeric";
import { validationMixin } from "vuelidate";
import { required, maxLength,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
      tgl1: { required },
      tgl2: { required },
      compcode: { required },
    }
  },  
  components: { Loading,vNumber, VueMonthlyPicker, lkuCompany },
  data() {
    return {
      companies:[],
      monthLabels: dropdown.monthLabels,
      showUploadFrm: false,
      fileXlsx: null,
      filter: null,
      filterOn:null,
      filterShow: 'Show',
      lkuCompanyShow: false,
      showForm:false,
      showReport:false,
      showDelConfirm: false,
      isLoading : false,
      horizontal: true,
      frmdata: {tgl1:'',tgl2:'',
        periode: moment(this.$store.state.user.tglaktifconsol, "YYYY-MM-DD")
          .add(1, "M")
          .subtract(1, "day")
      },

      model:{},
      tblData: {
        items: [],
        fields: [
          {
            key: "periode",
            thStyle: "width:100px",
            label: "Period"
          },
          {
            key: "kodeacc",
            label: "Account Code",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "namaacc",
            label: "Account Name",
          },
          {
            key: "typeacc",
            thStyle: "width:100px",
            label: "Type"
          },
          {
            key: "awal",
            label: "Begining Blc.",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "debet",
            label: "Debit",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "kredit",
            label: "Credit",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "akhir",
            label: "Ending Blc.",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right"
          },
        ],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        kodeacc: "",
        namaacc: "",
        tahun: new Date().getFullYear(),
        tahunBukuFrm :[]
      },
      tahunBuku:[],
      reportUrl: null
    };
  },
  created: async function() {
    this.companies= await consoltb.companies();
        // this.companies.forEach((kol, idx) => {
        //     kol.namakolom = `K${kol.value.replace(/ /g, '').replace('-','')}`;
        //     if (!(kol.compcolor)) {
        //         kol.compcolor= '#'+this.getRandomColor();
        //     }
        // });  
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  watch: {
    "frmdata.compcode": function(newVal) {
      const company = this.companies.find(c => c.compcode==newVal);
      if (company) {
         this.frmdata.company=company.text;
      }
    }
  },
  methods: {
    onSelectLkuCompany: async function (_selected) {
            this.frmdata.compcode= _selected.compcode;
            this.frmdata.company= _selected.company;
            this.frmdata.erpsource= _selected.erpsource;
          this.lkuCompanyShow=false;
    },  
    onChangeMonth: async function() {
      var tgl = moment(this.frmdata.periode);
      this.frmdata.tgl1 = tgl.startOf("month").format("YYYY-MM-DD");
      this.frmdata.tgl2 = tgl.endOf("month").format("YYYY-MM-DD");
      this.frmdata.tahun = tgl.format("YYYY");
    },
    downloadtemplate: async function() {
            try {
                const response = await consoltb.downloadtemplate();
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `EkosSystem-TB-upload-template.xlsx`);
                document.body.appendChild(link);
                link.click();
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }

    },    
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    getData: async function(ctx) {
        this.onChangeMonth();
      if (this.invalidFrmdata) {
          const invalidobj={};
          for (var key in this.$v.frmdata) {
            if (this.$v.frmdata[key].$anyError) {
              if (this.$v.frmdata[key].$anyError==true) invalidobj[key] = this.$v.frmdata[key];
            }
          }        
          console.log('validation frmdata: ', this.$v.frmdata);
          console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.');
       } else {
        try {
          this.isLoading=true;
          this.tblData.items = await consoltb.getdata(this.frmdata);
          this.tblData.total = this.tblData.items.length;  
          this.isLoading=false;    
          } catch (error) {
                  this.isLoading=false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
              this.isLoading=false;            
          }

       }
    },    
    getfromERP :async function(ctx) {
        this.onChangeMonth();
       if (this.invalidFrmdata) {
            toastr.error('Please fill the form correctly.');
       } else if (this.frmdata.erpsource!=1) {
            toastr.error('Unit Bussiness not available in EkosSystem ERP');
       } else {
        try {
          this.isLoading=true;
          if (this.frmdata.consolidated) {
            // untuk SUPER HOLDING, ambil TB dari Consolidated            
            this.tblData.items = await consoltb.getfromerpconsolidated(this.frmdata);
            console.log('consoltb.getfromerpconsolidated : ', this.tblData.items);
          } else {
          this.tblData.items = await consoltb.getfromerp(this.frmdata);
            console.log('consoltb.getfromerp : ', this.tblData.items);
          }
          this.tblData.total = this.tblData.items.length;  
          this.isLoading=false;    
          } catch (error) {
                  this.isLoading=false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
              this.isLoading=false;            
          }
       }
    },    
    uploadTB: async function() {
        this.onChangeMonth();
      if (this.invalidFrmdata) {
            console.log('validation : ', this.$v.frmdata);
            console.log('frmdata obj : ',this.frmdata);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if (this.fileXlsx) {
            this.showUploadFrm = false;
            this.isLoading=true;
            try {
                this.tblData.items = await consoltb.uploadtb(this.fileXlsx,this.frmdata);
                this.tblData.total = this.tblData.items.length;  
                this.isLoading=false;   
                toastr.success(`Complete sucessfully`,'UPLOAD/IMPORT INVOICE',10000);
            } catch (error) {
                this.isLoading=false;
                this.showUploadFrm = true;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
        } else {
          toastr.warn('Please select one File XLSX that want to Upload ');
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },

    deleteData: async function() {
      await consoltb.remove(this.model);
      this.refresh();
    },
    exportxls: async function() {
        this.onChangeMonth();
        if (this.invalidFilter) {
            console.log('model obj : ',this.filter);
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const response = await consoltb.exportxls(this.frmdata);
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `tb_unit_${this.frmdata.company}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);

                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }        
            }
       }
    },
    refresh() {
      this.$refs.table.refresh();
    },
    close(){
      router.push("home");
    }    
  }
};
</script>
